/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Batch,
    BatchFromJSON,
    BatchToJSON,
    CreateBatch,
    CreateBatchFromJSON,
    CreateBatchToJSON,
    PaginatedReportList,
    PaginatedReportListFromJSON,
    PaginatedReportListToJSON,
    PortfolioReport,
    PortfolioReportFromJSON,
    PortfolioReportToJSON,
} from '../models';

export interface ClaimsBillingReportRequest {
    dateTo?: string;
}

export interface CreateCncbBatchRequest {
    createBatch: CreateBatch;
}

export interface DealStatesReportRequest {
    dateTo?: string;
    person?: any;
    state?: any;
}

export interface DownloadReportRequest {
    id: number;
}

export interface GetCncbDealReportRequest {
    id: number;
    encoding?: string;
    repi?: boolean;
}

export interface GetPersonReportRequest {
    id: number;
    encoding?: string;
    repi?: boolean;
}

export interface GetPortfolioReportRequest {
    dateFrom?: Date;
    dateTo?: Date;
    dealStates?: GetPortfolioReportDealStatesEnum;
    dealTypes?: GetPortfolioReportDealTypesEnum;
}

export interface GetReportsRequest {
    type: GetReportsTypeEnum;
    ordering?: string;
    page?: number;
    pageSize?: number;
}

export interface PaymentsBillingReportRequest {
    dateTo?: string;
    deal?: number;
    paired?: boolean;
}

export interface SendRepiBatchRequest {
    id: string;
}

/**
 * ReportingApi - interface
 * 
 * @export
 * @interface ReportingApiInterface
 */
export interface ReportingApiInterface {
    /**
     * Endpoint generate claims report
     * @param {string} [dateTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApiInterface
     */
    claimsBillingReportRaw(requestParameters: ClaimsBillingReportRequest): Promise<runtime.ApiResponse<void>>;

    /**
     * Endpoint generate claims report
     */
    claimsBillingReport(requestParameters: ClaimsBillingReportRequest): Promise<void>;

    /**
     * 
     * @param {CreateBatch} createBatch 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApiInterface
     */
    createCncbBatchRaw(requestParameters: CreateCncbBatchRequest): Promise<runtime.ApiResponse<Batch>>;

    /**
     */
    createCncbBatch(requestParameters: CreateCncbBatchRequest): Promise<Batch>;

    /**
     * Endpoint generate deal state billing report
     * @param {string} [dateTo] 
     * @param {any} [person] 
     * @param {any} [state] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApiInterface
     */
    dealStatesReportRaw(requestParameters: DealStatesReportRequest): Promise<runtime.ApiResponse<void>>;

    /**
     * Endpoint generate deal state billing report
     */
    dealStatesReport(requestParameters: DealStatesReportRequest): Promise<void>;

    /**
     * 
     * @param {number} id A unique integer value identifying this report.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApiInterface
     */
    downloadReportRaw(requestParameters: DownloadReportRequest): Promise<runtime.ApiResponse<Blob>>;

    /**
     */
    downloadReport(requestParameters: DownloadReportRequest): Promise<Blob>;

    /**
     * 
     * @param {number} id A unique integer value identifying this cncb batch.
     * @param {string} [encoding] 
     * @param {boolean} [repi] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApiInterface
     */
    getCncbDealReportRaw(requestParameters: GetCncbDealReportRequest): Promise<runtime.ApiResponse<Blob>>;

    /**
     */
    getCncbDealReport(requestParameters: GetCncbDealReportRequest): Promise<Blob>;

    /**
     * 
     * @param {number} id A unique integer value identifying this cncb batch.
     * @param {string} [encoding] 
     * @param {boolean} [repi] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApiInterface
     */
    getPersonReportRaw(requestParameters: GetPersonReportRequest): Promise<runtime.ApiResponse<Blob>>;

    /**
     */
    getPersonReport(requestParameters: GetPersonReportRequest): Promise<Blob>;

    /**
     * 
     * @param {Date} [dateFrom] 
     * @param {Date} [dateTo] 
     * @param {'ACTIVE' | 'CLOSED' | 'CLOSED_APPLICATION' | 'CONTRACT_COMPLETION' | 'CONTRACT_SIGN' | 'FILED_FOR_INSOLVENCY' | 'NEW_APPLICATION'} [dealStates] 
     * @param {'CONSUMER_LOAN' | 'INVESTMENT_LOAN'} [dealTypes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApiInterface
     */
    getPortfolioReportRaw(requestParameters: GetPortfolioReportRequest): Promise<runtime.ApiResponse<PortfolioReport>>;

    /**
     */
    getPortfolioReport(requestParameters: GetPortfolioReportRequest): Promise<PortfolioReport>;

    /**
     * 
     * @param {'CLAIMS_REPORT' | 'DEALS_STATES_REPORT' | 'PAYMENTS_REPORT'} type 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApiInterface
     */
    getReportsRaw(requestParameters: GetReportsRequest): Promise<runtime.ApiResponse<PaginatedReportList>>;

    /**
     */
    getReports(requestParameters: GetReportsRequest): Promise<PaginatedReportList>;

    /**
     * Endpoint generate payment billing report
     * @param {string} [dateTo] 
     * @param {number} [deal] 
     * @param {boolean} [paired] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApiInterface
     */
    paymentsBillingReportRaw(requestParameters: PaymentsBillingReportRequest): Promise<runtime.ApiResponse<void>>;

    /**
     * Endpoint generate payment billing report
     */
    paymentsBillingReport(requestParameters: PaymentsBillingReportRequest): Promise<void>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApiInterface
     */
    sendRepiBatchRaw(requestParameters: SendRepiBatchRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    sendRepiBatch(requestParameters: SendRepiBatchRequest): Promise<void>;

}

/**
 * 
 */
export class ReportingApi extends runtime.BaseAPI implements ReportingApiInterface {

    /**
     * Endpoint generate claims report
     */
    async claimsBillingReportRaw(requestParameters: ClaimsBillingReportRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.dateTo !== undefined) {
            queryParameters['date_to'] = requestParameters.dateTo;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reporting/billing/claims-report/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Endpoint generate claims report
     */
    async claimsBillingReport(requestParameters: ClaimsBillingReportRequest): Promise<void> {
        await this.claimsBillingReportRaw(requestParameters);
    }

    /**
     */
    async createCncbBatchRaw(requestParameters: CreateCncbBatchRequest): Promise<runtime.ApiResponse<Batch>> {
        if (requestParameters.createBatch === null || requestParameters.createBatch === undefined) {
            throw new runtime.RequiredError('createBatch','Required parameter requestParameters.createBatch was null or undefined when calling createCncbBatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reporting/cncb/batch/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBatchToJSON(requestParameters.createBatch),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchFromJSON(jsonValue));
    }

    /**
     */
    async createCncbBatch(requestParameters: CreateCncbBatchRequest): Promise<Batch> {
        const response = await this.createCncbBatchRaw(requestParameters);
        return await response.value();
    }

    /**
     * Endpoint generate deal state billing report
     */
    async dealStatesReportRaw(requestParameters: DealStatesReportRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.dateTo !== undefined) {
            queryParameters['date_to'] = requestParameters.dateTo;
        }

        if (requestParameters.person !== undefined) {
            queryParameters['person'] = requestParameters.person;
        }

        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reporting/billing/deal-states-report/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Endpoint generate deal state billing report
     */
    async dealStatesReport(requestParameters: DealStatesReportRequest): Promise<void> {
        await this.dealStatesReportRaw(requestParameters);
    }

    /**
     */
    async downloadReportRaw(requestParameters: DownloadReportRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling downloadReport.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reporting/reports/{id}/download_report/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async downloadReport(requestParameters: DownloadReportRequest): Promise<Blob> {
        const response = await this.downloadReportRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getCncbDealReportRaw(requestParameters: GetCncbDealReportRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getCncbDealReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.encoding !== undefined) {
            queryParameters['encoding'] = requestParameters.encoding;
        }

        if (requestParameters.repi !== undefined) {
            queryParameters['repi'] = requestParameters.repi;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reporting/cncb/batch/{id}/deal-report/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async getCncbDealReport(requestParameters: GetCncbDealReportRequest): Promise<Blob> {
        const response = await this.getCncbDealReportRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getPersonReportRaw(requestParameters: GetPersonReportRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPersonReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.encoding !== undefined) {
            queryParameters['encoding'] = requestParameters.encoding;
        }

        if (requestParameters.repi !== undefined) {
            queryParameters['repi'] = requestParameters.repi;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reporting/cncb/batch/{id}/person-report/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async getPersonReport(requestParameters: GetPersonReportRequest): Promise<Blob> {
        const response = await this.getPersonReportRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getPortfolioReportRaw(requestParameters: GetPortfolioReportRequest): Promise<runtime.ApiResponse<PortfolioReport>> {
        const queryParameters: any = {};

        if (requestParameters.dateFrom !== undefined) {
            queryParameters['date_from'] = (requestParameters.dateFrom as any).toISOString().substr(0,10);
        }

        if (requestParameters.dateTo !== undefined) {
            queryParameters['date_to'] = (requestParameters.dateTo as any).toISOString().substr(0,10);
        }

        if (requestParameters.dealStates !== undefined) {
            queryParameters['deal_states'] = requestParameters.dealStates;
        }

        if (requestParameters.dealTypes !== undefined) {
            queryParameters['deal_types'] = requestParameters.dealTypes;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reporting/portfolio/report/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioReportFromJSON(jsonValue));
    }

    /**
     */
    async getPortfolioReport(requestParameters: GetPortfolioReportRequest): Promise<PortfolioReport> {
        const response = await this.getPortfolioReportRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getReportsRaw(requestParameters: GetReportsRequest): Promise<runtime.ApiResponse<PaginatedReportList>> {
        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type','Required parameter requestParameters.type was null or undefined when calling getReports.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reporting/reports/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedReportListFromJSON(jsonValue));
    }

    /**
     */
    async getReports(requestParameters: GetReportsRequest): Promise<PaginatedReportList> {
        const response = await this.getReportsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Endpoint generate payment billing report
     */
    async paymentsBillingReportRaw(requestParameters: PaymentsBillingReportRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.dateTo !== undefined) {
            queryParameters['date_to'] = requestParameters.dateTo;
        }

        if (requestParameters.deal !== undefined) {
            queryParameters['deal'] = requestParameters.deal;
        }

        if (requestParameters.paired !== undefined) {
            queryParameters['paired'] = requestParameters.paired;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reporting/billing/payments-report/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Endpoint generate payment billing report
     */
    async paymentsBillingReport(requestParameters: PaymentsBillingReportRequest): Promise<void> {
        await this.paymentsBillingReportRaw(requestParameters);
    }

    /**
     */
    async sendRepiBatchRaw(requestParameters: SendRepiBatchRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling sendRepiBatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reporting/repi/{id}/repi-report/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async sendRepiBatch(requestParameters: SendRepiBatchRequest): Promise<void> {
        await this.sendRepiBatchRaw(requestParameters);
    }

}

/**
    * @export
    * @enum {string}
    */
export enum GetPortfolioReportDealStatesEnum {
    Active = 'ACTIVE',
    Closed = 'CLOSED',
    ClosedApplication = 'CLOSED_APPLICATION',
    ContractCompletion = 'CONTRACT_COMPLETION',
    ContractSign = 'CONTRACT_SIGN',
    FiledForInsolvency = 'FILED_FOR_INSOLVENCY',
    NewApplication = 'NEW_APPLICATION'
}
/**
    * @export
    * @enum {string}
    */
export enum GetPortfolioReportDealTypesEnum {
    ConsumerLoan = 'CONSUMER_LOAN',
    InvestmentLoan = 'INVESTMENT_LOAN'
}
/**
    * @export
    * @enum {string}
    */
export enum GetReportsTypeEnum {
    ClaimsReport = 'CLAIMS_REPORT',
    DealsStatesReport = 'DEALS_STATES_REPORT',
    PaymentsReport = 'PAYMENTS_REPORT'
}
